import { render, staticRenderFns } from "./admin.clients.page.vue?vue&type=template&id=3831bb95&scoped=true&"
import script from "./admin.clients.page.vue?vue&type=script&lang=js&"
export * from "./admin.clients.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.clients.page.vue?vue&type=style&index=0&id=3831bb95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831bb95",
  null
  
)

export default component.exports